var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqQues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.26 17.52L9.82 14.88C9.22 15.0533 8.56 15.14 7.84 15.14C6.54667 15.14 5.35333 14.84 4.26 14.24C3.18 13.6267 2.32 12.78 1.68 11.7C1.05333 10.6067 0.74 9.38 0.74 8.02C0.74 6.66 1.05333 5.44 1.68 4.36C2.32 3.28 3.18 2.44 4.26 1.84C5.35333 1.22667 6.54667 0.919999 7.84 0.919999C9.14667 0.919999 10.34 1.22667 11.42 1.84C12.5133 2.44 13.3733 3.28 14 4.36C14.6267 5.44 14.94 6.66 14.94 8.02C14.94 9.3 14.66 10.46 14.1 11.5C13.5533 12.5267 12.7933 13.3533 11.82 13.98L15.16 17.52H12.26ZM3.08 8.02C3.08 9.04667 3.28 9.95333 3.68 10.74C4.09333 11.5133 4.66 12.1133 5.38 12.54C6.1 12.9533 6.92 13.16 7.84 13.16C8.76 13.16 9.58 12.9533 10.3 12.54C11.02 12.1133 11.58 11.5133 11.98 10.74C12.3933 9.95333 12.6 9.04667 12.6 8.02C12.6 6.99333 12.3933 6.09333 11.98 5.32C11.58 4.54667 11.02 3.95333 10.3 3.54C9.58 3.12667 8.76 2.92 7.84 2.92C6.92 2.92 6.1 3.12667 5.38 3.54C4.66 3.95333 4.09333 4.54667 3.68 5.32C3.28 6.09333 3.08 6.99333 3.08 8.02Z",
    fill: "#C44200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqQues);
export default __webpack_public_path__ + "static/media/faq_ques.b6c530889130bf2de8312cb34f2b0e8e.svg";
export { ForwardRef as ReactComponent };